module.exports = __webpack_public_path__ + "img/theplatform.23ec9a79.webp";